import axiosInstance from "../core/AxiosInstance";
import { AuthResponse } from "../model/AuthResponse";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

export class AuthService {
    private accessToken: string | null = null;
    private url: string = ''

    constructor(url: string) {
        this.url = url;
    }

    async login(credentials: { username: string; password: string }) {
        try {
            const response = await axiosInstance.post<AuthResponse>(
                this.url, credentials
            );
            // Store access token in memory (optional)
            this.accessToken = response.data.accessToken || null;
            localStorage.setItem("accessToken", this.accessToken || "");
            return response.data.accessToken;
        }
        catch (error) {
            return null;
        }
    }

    async refreshAccessToken() {
        const response = await axiosInstance.get<AuthResponse>(
            `${API_BASE_URL}/api/matiga/pesowifi/apiauth/refreshtoken`
        );
        this.accessToken = response.data.accessToken || null;
        return response.data.accessToken;
    }

    // getAccessToken() {
    //     return this.accessToken;
    // }

    // clearTokens() {
    //     this.accessToken = null;
    // }
}